import React from "react";
import { IconButton } from "@mui/material";
import MagicButtonImg from "../img/MagicButton.svg";

interface MagicButtonProps {
  position: { top: number; left: number };
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
}

const MagicButtonComp: React.FC<MagicButtonProps> = ({ position, onClick }) => (
  <IconButton
    size="large"
    className="contextual-button"
    sx={{
      position: "absolute",
      top: position.top,
      left: position.left,
      backgroundColor: "#4C7592",
      color: "white",
      "&:hover": { backgroundColor: "#1D4052" },
      zIndex: 5,
    }}
    id="basic-button"
    aria-controls="magic-popover"
    aria-haspopup="true"
    onClick={onClick}
  >
    <img src={MagicButtonImg} alt="Botón mágico" style={{ width: 40, height: 40 }} />
  </IconButton>
);

export default MagicButtonComp;
